import React, { useState } from "react";
import Card from "components/card";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { patchChangePassword } from "../../../redux/action/index";
import { getCookie } from "utils/cookie";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmNewPasswordError, setConfirmNewPasswordError] = useState("");
  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validateNewPassword = (newPassword) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
    if (!passwordRegex.test(newPassword)) {
      setNewPasswordError(
        "Password must be at least 12 characters long, include one special character, one number, one lowercase, and one uppercase letter."
      );
      return false;
    }
    setNewPasswordError("");
    return true;
  };

  const validateConfirmNewPassword = (confirmNewPassword) => {
    if (confirmNewPassword !== newPassword) {
      setConfirmNewPasswordError("Passwords do not match.");
      return false;
    }
    setConfirmNewPasswordError("");
    return true;
  };

  const validateCurrentPassword = (currentPassword) => {
    if (!currentPassword) {
      setCurrentPasswordError("Current Password is required");
      return false;
    }
    setCurrentPasswordError("");
    return true;
  };

  const handleSubmitData = () => {
    const isCurrentPasswordValid = validateCurrentPassword(currentPassword);
    const isNewPasswordValid = validateNewPassword(newPassword);
    const isConfirmPasswordValid =
      validateConfirmNewPassword(confirmNewPassword);

    if (
      isCurrentPasswordValid &&
      isNewPasswordValid &&
      isConfirmPasswordValid
    ) {
      setLoading(true);
      try {
        dispatch(
          patchChangePassword({
            account_id: getCookie("account_id"),
            current_password: currentPassword,
            change_password: newPassword,
          })
        ).then((response) => {
          setLoading(false);
          if (response !== undefined) {
            navigate("/auth/sign-in");
          }
        });
      } catch (error) {
        setLoading(false);
        console.error("Error:", error);
      }
    } else {
      console.log("Validation errors");
    }
  };

  return (
    <Card extra={"w-full h-full p-3"}>
      <div className="relative mb-3 flex items-center justify-between pt-1">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          Change Password
        </h4>
      </div>

      <div className="grid grid-cols-2 gap-2 px-1">
        {/* Current Password */}
        <div className="relative mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Current password<span className="text-red-500">*</span>
          </label>
          <input
            type={showCurrentPassword ? "text" : "password"}
            value={currentPassword}
            onChange={(e) => {
              setCurrentPassword(e.target.value);
              validateCurrentPassword(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          <span
            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
            className="absolute right-3 top-10 cursor-pointer"
          >
            {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
          {currentPasswordError && (
            <p className="mt-1.5 text-sm text-red-500">
              {currentPasswordError}
            </p>
          )}
        </div>

        <div></div>

        {/* New Password */}
        <div className="relative mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            New Password<span className="text-red-500">*</span>
          </label>
          <input
            type={showNewPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              validateNewPassword(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          <span
            onClick={() => setShowNewPassword(!showNewPassword)}
            className="absolute right-3 top-10 cursor-pointer"
          >
            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
          {newPasswordError && (
            <p className="mt-1.5 text-sm text-red-500">{newPasswordError}</p>
          )}
        </div>
        <div></div>

        {/* Confirm New Password */}
        <div className="relative mb-2">
          <label className="mb-2 block text-sm font-medium text-gray-900 dark:text-white">
            Confirm New Password<span className="text-red-500">*</span>
          </label>
          <input
            type={showConfirmNewPassword ? "text" : "password"}
            value={confirmNewPassword}
            onChange={(e) => {
              setConfirmNewPassword(e.target.value);
              validateConfirmNewPassword(e.target.value);
            }}
            className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
          />
          <span
            onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
            className="absolute right-3 top-10 cursor-pointer"
          >
            {showConfirmNewPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
          {confirmNewPasswordError && (
            <p className="mt-1.5 text-sm text-red-500">
              {confirmNewPasswordError}
            </p>
          )}
        </div>
      </div>

      {/* Submit Button */}
      <button
        onClick={handleSubmitData}
        disabled={submitting || loading}
        className={`linear mt-3 w-1/4 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white disabled:bg-gray-400 ${
          submitting || loading ? "cursor-not-allowed" : null
        }`}
      >
        {submitting || loading ? "Submitting..." : "Submit"}
      </button>
    </Card>
  );
};

export default ChangePassword;
